import { makeStyles, tokens } from '@fluentui/react-components';

export const mobileWidthBreakpoint = 470;

export const useItemListStyles = makeStyles({
    root: {},
    title: {
        display: 'inline-flex',
        minWidth: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    tabListRoot: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: '10px',
    },
    tabList: {},
    tab: {
        '&.fui-Tab[aria-selected=true], &.fui-Tab[aria-selected=true]:hover, &.fui-Tab[aria-selected=true]:active':
            {
                backgroundColor: tokens.colorBrandBackground,
                '& span.fui-Text': {
                    color: tokens.colorNeutralForegroundOnBrand,
                },
            },
        '&.fui-Tab:hover, &.fui-Tab:active': {
            backgroundColor: tokens.colorTransparentBackground,
            '& span.fui-Text': {
                color: tokens.colorNeutralForeground2,
            },

            '&::before, &::after': {
                content: 'none !important',
            },
        },
        '&::before, &::after': {
            content: 'none !important',
        },
    },
    accordionHeader: {
        '& > button[aria-expanded="true"]': {
            backgroundColor: tokens.colorBrandBackground,
            color: tokens.colorNeutralForegroundOnBrand,
            borderRadius: '8px 8px 0px 0px',
        },
    },
    hideExpandIcon: {
        '& .fui-AccordionHeader__expandIcon': {
            visibility: 'hidden',
        },
    },
    itemTitle: {
        padding: '0 30px',
    },
    accordionPannel: {
        margin: '0',
        gap: '8px',
        borderRadius: '0 0 8px 8px',
        border: `1px solid ${tokens.colorNeutralStroke1}`,
        padding: '8px 16px',
    },
    tabListItemInfo: {
        flex: '1  1 max-content',
        borderRadius: '8px',
        border: `1px solid ${tokens.colorNeutralStroke1}`,
        padding: '8px 16px',
        margin: '0 0 10px',
    },
});
